module.exports = __webpack_public_path__ + "static/media/sequipament.e8dd3f7b.svg";